import React from 'react'
import Link from '@mui/material/Link';
function Developed() {

    return (
        <span>
            Web Design & Development by <Link href="https://webdesignexpressions.net/" target="_blank" rel="noreferrer" style={{ color: 'inherit' }}>Web Design Expressions, Inc</Link>
        </span>
    )
}

export default Developed